export default __webpack_public_path__ + "static/media/20_header_salesOrder.450b7dfc.png";